import { baseUrl } from './routes';

export class InitialAssessmentRoutes {
  static get initialAssessment(): string {
    return `${baseUrl}/medical/initial-assessment`;
  }
  static get create(): string {
    return `${this.initialAssessment}/create`;
  }
  static get edit(): string { // append /:assessment_id/edit when used
    return `${this.initialAssessment}`;
  }
  static get profile(): string { // append /:assessment_id when used
    return `${this.initialAssessment}`;
  }
}
